var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "subproject-group" }, [
    _c(
      "div",
      {
        staticClass:
          "group h48 bg-fa flex-start-center cursor-p text-no-select mb4",
        on: { click: _vm.resizeH },
      },
      [
        _c("yxt-svg", {
          staticClass: "flex-shrink-0 text-26 ml12",
          class: { "vb-hidden": _vm.num === 0 },
          attrs: {
            "icon-class": _vm.checkStatus ? "down" : "right",
            width: "20px",
            height: "20px",
          },
        }),
        _c(
          "div",
          {
            staticClass:
              "c-26 font-size-14 font-bold max-800 ellipsis ml12 mr16",
          },
          [_vm._v(_vm._s(_vm.title))]
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show",
          },
        ],
        ref: "wrapRef",
        staticClass: "group-drop-tran over-hidden",
        on: { transitionend: _vm.onTransitionEnd },
      },
      [
        _c(
          "div",
          { ref: "unfoldRef", staticClass: "pl32" },
          [_vm._t("default")],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }